//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  props: {
    locales: {type: Array, default: () => ['fr', 'en']},
  },
  methods: {
    setLocale (locale) {
      this.$i18n.setLocale(locale)
      window.location.reload()
    }
  }
}
